/**
 * Labstep
 *
 * @module containers/User/Login
 * @desc Login container
 */

import {
  getSAMLLoginUrlAction,
  requestGetSAMLLoginUrlActionType,
} from 'labstep-web/state/actions/user';
import { selectApiStatus } from 'labstep-web/state/selectors/ui';
import { connect } from 'react-redux';

const ChildrenContainer = ({ children, ...rest }: any) =>
  children(rest);

const mapStateToProps = (state: any) => ({
  status: selectApiStatus(state, requestGetSAMLLoginUrlActionType),
});

const mapDispatchToProps = (dispatch: (...args: any[]) => void) => ({
  getSAMLLoginUrl: (organization: string, options?: any) => {
    dispatch(getSAMLLoginUrlAction(organization, options));
  },
});

export const UserGetSAMLLoginUrlContainer = connect<any, any, any>(
  mapStateToProps,
  mapDispatchToProps,
)(ChildrenContainer);
